function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_131_3162)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0521 2.98804L16.6577 4.34004L18.574 3.56056L19.7135 5.32804L21.7853 5.12004L22.355 7.14804L24.375 7.56456L24.3232 9.64456L26.1359 10.684L25.5139 12.66L26.9641 14.168L25.7734 15.884L26.7057 17.756L25.0483 19.056L25.4108 21.136L23.4427 21.8646L23.1832 23.9446L21.1119 24.0486L20.2314 25.972L18.2115 25.452L16.813 27.012L15.0003 25.9206L13.1875 27.012L11.789 25.452L9.76908 25.972L8.88859 24.0486L6.81735 23.9446L6.55786 21.8646L4.58918 21.136L4.95225 19.056L3.29485 17.756L4.22714 15.884L3.03588 14.168L4.48663 12.66L3.86458 10.684L5.67737 9.64456L5.62557 7.56456L7.64553 7.09604L8.21527 5.06804L10.287 5.27604L11.4788 3.56056L13.3947 4.34004L15.0521 2.98804ZM8.64478 13.1476V17.0476C8.64478 18.1688 9.22256 18.8026 10.2818 18.8026C11.3411 18.8026 11.9189 18.1688 11.9189 17.0476V16.0233H10.8596V17.1451C10.8596 17.6326 10.6189 17.8276 10.2818 17.8276C9.94478 17.8276 9.70404 17.6326 9.70404 17.1451V13.0988C9.70404 12.6113 9.94478 12.4163 10.2818 12.4163C10.6189 12.4163 10.8596 12.6113 10.8596 13.0988V13.9276H11.9189V13.1476C11.9189 12.0751 11.3411 11.3926 10.2818 11.3926C9.22256 11.3926 8.64478 12.0263 8.64478 13.1476ZM12.6894 11.4899H14.2301L14.9524 16.6579L15.6746 11.4899H17.2635V18.7049H16.2042V13.2449L15.3857 18.7049H14.4709L13.6524 13.2449V18.7049H12.6894V11.4899ZM21.211 11.4899H18.13V18.7049H21.211V17.6812H19.2851V15.4391H20.8263V14.4149H19.2851V12.5137H21.211V11.4899Z",
  fill: "#0DFFF3"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_131_3162",
  x: -1,
  y: 0,
  width: 32,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_131_3162"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_131_3162",
  result: "effect2_dropShadow_131_3162"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_131_3162",
  result: "effect3_dropShadow_131_3162"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_131_3162",
  result: "shape"
})));

function SvgCme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCme);
export default __webpack_public_path__ + "static/media/CME.ebfe045a.svg";
export { ForwardRef as ReactComponent };